module.exports = __webpack_public_path__ + "img/c01_unitstartechtoxoteschampion_Normal_ua.c9b0fbb0.webp";